<div class="container-fluid">
  <div class="container popGrid">
    <div class="row">
      <div class="mini-headers" >
        <h4 class="subHeaders">
          {{ title }}
          <span class="viewAll">
            View All
          </span>
        </h4>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="cardGrid" style="padding: 10px 15px;">
        <div class="imageContainer scroll-card" *ngFor="let item of data">
          <div class="" style="  position: relative;">
            <img class="img-fluid imageCard" [src]="item.image" [alt]="item.title">
          </div>
          <div class="p-1"></div>
          <p class="" style="font-weight: 400; font-size: 12px; line-height: 120%;">
            {{ item.name }}
          </p>
          <p class="" style="font-weight: 500; font-size: 16px; line-height: 120%;">
            ₦{{ item.price  | number  }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="p-5 d-none d-md-block"></div>

<div class="p-4  d-sm-block d-md-none"></div>
